import { createIcon } from "@chakra-ui/react";

export const PlayStoreIcon = createIcon({
  viewBox: "0 0 22 24",
  path: [
    <g clip-path="url(#clip0_3561_37633)">
      <path
        d="M16.2318 15.6965C19.0159 14.1361 21.1449 12.9473 21.3269 12.8544C21.9092 12.5386 22.5097 11.7027 21.3269 11.0526C20.9448 10.8482 18.8885 9.69652 16.2318 8.21045L12.5742 11.9628L16.2318 15.6965Z"
        fill="#FFD400"
      />
      <path
        d="M12.574 11.9629L0.891602 23.9815C1.16455 24.0186 1.4739 23.9443 1.83784 23.74C2.60211 23.3127 10.7179 18.7802 16.2316 15.6966L12.574 11.9629Z"
        fill="#FF3333"
      />
      <path
        d="M12.5736 11.9629L16.2312 8.21062C16.2312 8.21062 2.65634 0.650242 1.83748 0.204422C1.52813 0.0186632 1.18239 -0.0370644 0.873047 0.0186632L12.5736 11.9629Z"
        fill="#48FF48"
      />
      <path
        d="M12.574 11.9628L0.873449 0.0185547C0.400331 0.13001 0 0.557256 0 1.43032C0 2.82351 0 21.3994 0 22.5696C0 23.3684 0.309347 23.9443 0.891646 24L12.574 11.9628Z"
        fill="#3BCCFF"
      />
    </g>,
    <defs>
      <clipPath id="clip0_3561_37633">
        <rect width="22" height="24" fill="white" />
      </clipPath>
    </defs>,
  ],
});
